import React, { useEffect } from 'react';
import ContactComp from "../ContactUS_component/ContactComp.js";
import HeroContent from '../Hero_component/Hero.js';

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component loads
  }, []);
    return (
      <>
      <HeroContent title ="Contact Us" image={require('../../resource/Banner/contact.jpg')}/>
      <ContactComp />
      </>
    );
  }
  
  export default Contact;